module.exports = function(locale, preview) {
  return `fragment PageMetaDataFragment on PageMetaData {
    sys {
      id
    }
    __typename
    pageTitle
    metaTitle
    metaDescription
    metaKeywords
    openGraphPageTitle
    openGraphDescription
  }

  {
    sitemapCollection(limit: 1, locale:"${locale}", preview:${preview}){
      items{
        sys{
          id
        }
        pageHeading
        pageMetadata {
          ... on PageMetaData {
            ...PageMetaDataFragment
          }
        }
        sitemapSectionCollection(limit:4){
          items{
            sys{
              id
            }
            title
            styles
            childPageCollection(limit: 7){
              items{
                __typename
                ... on MenuSlot{
                  styles
                  title
                  link
                }
                ... on SitemapSection{
                  parentPageCollection(limit: 1){
                    items{
                      __typename
                      ... on MenuSlot{
                        title
                        link
                      }
                    }
                  }
                  styles
                  childPageCollection(limit: 15){
                    items{
                      __typename
                      ... on MenuItem{
                        styles
                        menuText
                        menuLink
                      }
                    }
                  }
                }
              }
            }
            parentPageCollection(limit:1){
              items{
                __typename
                ... on MegaMenu{
                  menuLink
                  menuText
                }
              }
            }
          }
        }
      }
    }
  }`;
};
